var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_arrow_-_right",
    "data-name": "icon - arrow - right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M928.771,141.09l-6.218,6.249a1.589,1.589,0,0,1-1.122.45,1.626,1.626,0,0,1-1.155-.452l-.545-.58a1.553,1.553,0,0,1-.48-1.129,1.622,1.622,0,0,1,.462-1.16l4.544-4.523-4.522-4.5a1.561,1.561,0,0,1-.484-1.153,1.541,1.541,0,0,1,.48-1.121l.545-.576a1.637,1.637,0,0,1,1.155-.449,1.593,1.593,0,0,1,1.122.45l6.218,6.249a1.55,1.55,0,0,1,0,2.245Z",
    transform: "translate(-911.252 -126.968)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.aa33d0e9ea40b088cd5d83509ae07bfb.svg";
export { ForwardRef as ReactComponent };